import React from "react";
import styled from "styled-components";
import { Icon } from "./Icon";
import { ALERT_TYPES, AlertType } from "./constants/alerts";
import { LoadingState } from "./states/LoadingState";
import { style } from "./style";

type IconContentProps = {
  icon: string;
  type?: "default" | AlertType;
  prefix?: string;
  className?: string;
};

type AlertContentProps = {
  type: AlertType;
  prefix?: string;
  className?: string;
};

type ContainerProps = {
  type: "default" | AlertType;
  prefix?: string;
  className?: string;
};

const Container = styled.div<ContainerProps>`
  color: ${({ type }) => (type != AlertType.ERROR ? style.colors.grey.darkest : ALERT_TYPES[type].fgColor)};
  display: flex;
  align-items: flex-start;
  margin: ${style.vars.whitespace.regular} ${style.vars.whitespace.small};
`;

const IconContainer = styled(Icon)`
  margin-right: ${style.vars.whitespace.small};
  flex: none;
`;

const Spinner = styled(LoadingState)`
  margin-right: ${style.vars.space["2"]};
`;

const ChildrenContainer = styled.div``;

const PrefixContainer = styled.strong``;

export const IconContent: React.FC<IconContentProps> = ({ type = "default", icon, children, prefix, className }) => {
  return (
    <Container type={type} className={className}>
      {type === "loading" ? (
        <Spinner aria-hidden="true" />
      ) : (
        <IconContainer large icon={icon} svgProps={{ "aria-hidden": true, focusable: false }} />
      )}
      <ChildrenContainer>
        {prefix && <PrefixContainer>{prefix} </PrefixContainer>}
        {children}
      </ChildrenContainer>
    </Container>
  );
};

export const AlertContent: React.FC<AlertContentProps> = ({ type, children, prefix, className }) => (
  <IconContent icon={ALERT_TYPES[type].icon} type={type} prefix={prefix} className={className}>
    {children}
  </IconContent>
);
